import { render, staticRenderFns } from "./modal-add.vue?vue&type=template&id=0f78d4e6&scoped=true"
import script from "./modal-add.vue?vue&type=script&lang=js"
export * from "./modal-add.vue?vue&type=script&lang=js"
import style0 from "./modal-add.vue?vue&type=style&index=0&id=0f78d4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78d4e6",
  null
  
)

export default component.exports